
import React from 'react'
import Row from 'components/Common/Row'
import Col from 'components/Common/Col'
import LayoutContainer from 'components/Common/LayoutContainer'
import PaymentMethods from './PaymentMethods'
import FollowUsLinks from './FollowUsLinks'
import AppLinks from './AppLinks'

export default () => (
  <LayoutContainer>
    <Row>
      <Col sm={3}>
        <FollowUsLinks />
      </Col>
      <Col sm={5}>
        <AppLinks />
      </Col>
      <Col sm={4} className="hidden-print">
        <PaymentMethods />
      </Col>
    </Row>
  </LayoutContainer>
)
